<div class="flex-container">
  <div class="flex-item filter-label">
    From Date
    <div class="flex-item">
      <p-calendar
        [(ngModel)]="fromDate"
        dateFormat="dd/mm/yy"
        (ngModelChange)="dateRangeChanged($event)"
        name="fromDate"
        appendTo="body"
      ></p-calendar>
    </div>
  </div>

  <div class="flex-item filter-label">
    To Date
    <div class="flex-item">
      <p-calendar
        [(ngModel)]="toDate"
        dateFormat="dd/mm/yy"
        (ngModelChange)="dateRangeChanged($event)"
        name="toDate"
        appendTo="body"
      ></p-calendar>
    </div>
  </div>

  <div class="flex-item filter-label">
    Status Filter
    <div class="flex-item" style="position: relative; top: -3px">
      <p-dropdown
        name="customers"
        [options]="jobFilterOptions"
        [(ngModel)]="jobFilter"
        (onChange)="jobFilterChanged()"
        styleClass="filterItem"
        [style]="{ width: '100px' }"
        appendTo="body"
      ></p-dropdown>
    </div>
  </div>

  <div class="flex-item filter-label">
    <button
      pButton
      type="button"
      icon="fa ui-icon-restore"
      class="button-style btn-sm ui-tertiary-button ml-2"
      (click)="resetFilters()"
    ></button>
  </div>
</div>

<div *ngIf="!isLoading && (!jobs || jobs.length == 0)" class="no-jobs">
  <div style="text-align: center">No Close/Cancelled Jobs</div>
</div>

<jobs-information-list
  [impersonating]="impersonating"
  [homePosition]="supplierHomePos"
  [jobs]="viewedJobs"
  [busy]="isLoading"
></jobs-information-list>
